<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="工作计划"
      width="1100px"
      :innerHeight="560"
      @close="updateVal"
      :showFooter="false"
    >
      <!-- // 业务 -->
      <el-form :model="formData" :inline="true" size="small">
        <el-form-item label="SKU编码">
          <el-input v-model.trim="formData.skuCode"></el-input>
        </el-form-item>
        <el-form-item label="计划人员">
          <el-select class="form-input" v-model="formData.planPerson" clearable>
            <el-option v-for="person in planPersonList"
              :key="person.planPersonId"
              :label="person.planPersonName"
              :value="person.planPersonName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="batchUpdate" v-if="!publishedTable.length" v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$workPlanBatchEdit`">批量更新</el-button>
          <el-button plain @click="batchUpdate" v-else>更新完成</el-button>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button type="warning" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 已填写计划的sku -->
      <el-table
        border
        :header-cell-style="{backgroundColor: '#F4F8FB'}"
        :data="publishedTable"
        :height="240"
        :row-class-name="tableRowClassName"
        :span-method="spanMethod"
        v-loading="loading"
        v-if="publishedTable.length"
      >
        <el-table-column label="SKU编码" prop="skuCode" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="SKU名称" prop="skuName" min-width="150" show-overflow-tooltip></el-table-column>
        <template v-if="hasPhotographyPlan">
          <el-table-column label="拍摄计划" prop="planShooting" show-overflow-tooltip width="225px">
            <template slot-scope="scope">
              <el-date-picker
                v-if="scope.row.disable && scope.row.taskId <= stepEnum.shooting"
                class="date-input"
                size="mini"
                :picker-options="pickerOptions"
                v-model="scope.row.shootingPlan"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <span v-else>{{scope.row.shootingPlanDisp}}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际拍摄" prop="actualShooting" show-overflow-tooltip width="150px">
            <template slot-scope="scope">
              {{scope.row.actualShootingStart}}
              <span v-if="scope.row.actualShooting"> 至 {{scope.row.actualShooting}}</span>
            </template>
          </el-table-column>
          <el-table-column label="拍摄人员" prop="shootPersonId" show-overflow-tooltip width="120px">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.shootPersonId"
                filterable=""
                placeholder="请选择"
                v-if="scope.row.disable && +scope.row.taskId <= 103"
                >
                <el-option
                  v-for="item in captureUserList"
                  :key="item.userId"
                  :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                  :value="item.userId">
                </el-option>
              </el-select>
              <!-- <el-input v-model.trim="scope.row.shootPerson" v-if="scope.row.disable && +scope.row.taskId <= 103"></el-input> -->
              <span v-else>{{scope.row.shootPerson}}</span>
            </template>
          </el-table-column>
          <el-table-column label="计划修片" prop="planRetouching" show-overflow-tooltip width="225">
            <template slot-scope="scope">
              <el-date-picker
                v-if="scope.row.disable && scope.row.taskId <= stepEnum.retouching"
                class="date-input"
                size="mini"
                :picker-options="pickerOptions"
                v-model="scope.row.retouchingPlan"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <span v-else>{{scope.row.retouchingPlanDisp}}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际修片" prop="actualRetouching" show-overflow-tooltip width="150px">
            <template slot-scope="scope">
              {{scope.row.actualRetouchingStart}}
              <span v-if="scope.row.actualRetouching"> 至 {{scope.row.actualRetouching}}</span>
            </template>
          </el-table-column>
          <el-table-column label="修片人员" prop="retouchingPersonId" show-overflow-tooltip width="120px">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.retouchingPersonId"
                filterable=""
                placeholder="请选择"
                v-if="scope.row.disable && +scope.row.taskId <= 104"
                >
                <el-option
                  v-for="item in userList"
                  :key="item.userId"
                  :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                  :value="item.userId">
                </el-option>
              </el-select>
              <!-- <el-input v-model.trim="scope.row.retouchingPerson" v-if="scope.row.disable && +scope.row.taskId <= 104"></el-input> -->
              <span v-else>{{scope.row.retouchingPerson}}</span>
            </template>
          </el-table-column>
        </template>
        <!-- 渲染计划 -->
        <template v-if="renderPlan">
          <!-- 是否跳过了渲染节点 -->
          <template v-if="!isJumpRender">
            <el-table-column label="计划渲染" prop="planDesign" show-overflow-tooltip width="225">
              <template slot-scope="scope">
                <el-date-picker
                  v-if="scope.row.disable"
                  class="date-input"
                  size="mini"
                  :picker-options="pickerOptions"
                  v-model="scope.row.renderPlan"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
                <span v-else>{{scope.row.renderPlanDisp}}</span>
              </template>
            </el-table-column>
            <el-table-column label="实际渲染" prop="actualDesign" show-overflow-tooltip width="150px">
              <template slot-scope="scope">
                {{scope.row.actualRenderStart}}
                <span v-if="scope.row.actualRetouching"> 至 {{scope.row.actualRetouching}}</span>
              </template>
            </el-table-column>
            <el-table-column label="渲染人员" prop="planRenderPersonId" show-overflow-tooltip width="120px">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.planRenderPersonId"
                  filterable=""
                  placeholder="请选择"
                  v-if="scope.row.disable && +scope.row.taskId <= 107"
                  >
                  <el-option
                    v-for="item in userList"
                    :key="item.userId"
                    :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                    :value="item.userId">
                  </el-option>
                </el-select>
                <!-- <el-input v-model.trim="scope.row.designPerson" v-if="scope.row.disable && +scope.row.taskId <= 107"></el-input> -->
                <span v-else>{{scope.row.planRenderPerson}}</span>
              </template>
            </el-table-column>
          </template>
        </template>
        <template v-if="hasPagePlan">
          <!-- 是否跳过了设计节点 -->
          <!-- <template v-if="!isJumpDesign">
            <el-table-column label="计划设计" prop="planDesign" show-overflow-tooltip width="225">
              <template slot-scope="scope">
                <el-date-picker
                  v-if="scope.row.disable && scope.row.taskId <= stepEnum.design"
                  class="date-input"
                  size="mini"
                  :picker-options="pickerOptions"
                  v-model="scope.row.designPlan"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
                <span v-else>{{scope.row.designPlanDisp}}</span>
              </template>
            </el-table-column>
            <el-table-column label="实际设计" prop="actualDesign" show-overflow-tooltip width="150px">
              <template slot-scope="scope">
                {{scope.row.actualDesignStart}}
                <span v-if="scope.row.actualDesign"> 至 {{scope.row.actualDesign}}</span>
              </template>
            </el-table-column>
            <el-table-column label="设计人员" prop="designPersonId" show-overflow-tooltip width="120px">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.designPersonId"
                  filterable=""
                  placeholder="请选择"
                  v-if="scope.row.disable && +scope.row.taskId <= 107"
                  >
                  <el-option
                    v-for="item in userList"
                    :key="item.userId"
                    :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                    :value="item.userId">
                  </el-option>
                </el-select>
                <span v-else>{{scope.row.designPerson}}</span>
              </template>
            </el-table-column>
          </template> -->
          <el-table-column label="计划切片" prop="planSection" show-overflow-tooltip width="225">
            <template slot-scope="scope">
              <el-date-picker
                v-if="scope.row.disable && scope.row.taskId <= stepEnum.sectioning"
                class="date-input"
                size="mini"
                :picker-options="pickerOptions"
                v-model="scope.row.sectionPlan"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <span v-else>{{scope.row.sectionPlanDisp}}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际切片" prop="actualSection" show-overflow-tooltip width="150px">
            <template slot-scope="scope">
              {{scope.row.actualSectionStart}}
              <span v-if="scope.row.actualSection"> 至 {{scope.row.actualSection}}</span>
            </template>
          </el-table-column>
          <el-table-column label="切片人员" prop="sectionPersonId" show-overflow-tooltip width="120px">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.sectionPersonId"
                filterable=""
                placeholder="请选择"
                v-if="scope.row.disable && +scope.row.taskId <= 108"
                >
                <el-option
                  v-for="item in userList"
                  :key="item.userId"
                  :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                  :value="item.userId">
                </el-option>
              </el-select>
              <!-- <el-input v-model.trim="scope.row.sectionPerson" v-if="scope.row.disable && +scope.row.taskId <= 108"></el-input> -->
              <span v-else>{{scope.row.sectionPerson}}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" fixed="right" width="110px" align="center">
          <template slot-scope="scope">
            <template v-if="+scope.row.taskId < 109">
              <el-link :underline="false" type="primary" @click="asyncPlan(scope.row)" v-if="publishedTable.length">同计划</el-link>
              <el-link
                :underline="false"
                type="primary"
                @click="edit(scope.row)"
                v-if="!scope.row.disable"
                v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$workPlanEdit`">调整</el-link>
              <template v-else>
                <el-link :underline="false" type="primary" @click="cancel(scope.row)">取消</el-link>
                <el-link :underline="false" type="primary" @click="save(scope.row)">保存</el-link>
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <!-- 全部sku -->
      <el-table
        border
        :header-cell-style="{backgroundColor: '#F4F8FB'}"
        :data="tableData"
        :height="240"
        :row-class-name="tableRowClassName"
        :span-method="spanMethod"
        v-loading="loading"
        @selection-change="handleSelected"
        style="margin-top: 15px;"
      >
        <el-table-column type="selection" v-if="publishedTable.length"></el-table-column>
        <el-table-column label="SKU编码" prop="skuCode" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="SKU名称" prop="skuName" min-width="150" show-overflow-tooltip></el-table-column>
        <!-- 摄影计划 -->
        <template v-if="hasPhotographyPlan">
          <el-table-column label="拍摄计划" prop="planShooting" show-overflow-tooltip width="225px">
            <template slot-scope="scope">
              <el-date-picker
                v-if="scope.row.disable && scope.row.taskId <= stepEnum.shooting"
                class="date-input"
                size="mini"
                :picker-options="pickerOptions"
                v-model="scope.row.shootingPlan"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <span v-else>{{scope.row.shootingPlanDisp}}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际拍摄" prop="actualShooting" show-overflow-tooltip width="150px">
            <template slot-scope="scope">
              {{scope.row.actualShootingStart}}
              <span v-if="scope.row.actualShooting"> 至 {{scope.row.actualShooting}}</span>
            </template>
          </el-table-column>
          <el-table-column label="拍摄人员" prop="shootPersonId" show-overflow-tooltip width="120px">
            <template slot-scope="scope">
              <!-- <el-input v-model.trim="scope.row.shootPerson" v-if="scope.row.disable && +scope.row.taskId <= 103"></el-input> -->
              <el-select
                  v-model="scope.row.shootPersonId"
                  filterable=""
                  placeholder="请选择"
                  v-if="scope.row.disable && +scope.row.taskId <= 103"
                  >
                  <el-option
                    v-for="item in captureUserList"
                    :key="item.userId"
                    :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                    :value="item.userId">
                  </el-option>
                </el-select>
              <span v-else>{{scope.row.shootPerson}}</span>
            </template>
          </el-table-column>
          <el-table-column label="计划修片" prop="planRetouching" show-overflow-tooltip width="225">
            <template slot-scope="scope">
              <el-date-picker
                v-if="scope.row.disable && scope.row.taskId <= stepEnum.retouching"
                class="date-input"
                size="mini"
                :picker-options="pickerOptions"
                v-model="scope.row.retouchingPlan"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <span v-else>{{scope.row.retouchingPlanDisp}}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际修片" prop="actualRetouching" show-overflow-tooltip width="150px">
            <template slot-scope="scope">
              {{scope.row.actualRetouchingStart}}
              <span v-if="scope.row.actualRetouching"> 至 {{scope.row.actualRetouching}}</span>
            </template>
          </el-table-column>
          <el-table-column label="修片人员" prop="retouchingPersonId" show-overflow-tooltip width="120px">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.retouchingPersonId"
                filterable=""
                placeholder="请选择"
                v-if="scope.row.disable && +scope.row.taskId <= 104"
                >
                <el-option
                  v-for="item in userList"
                  :key="item.userId"
                  :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                  :value="item.userId">
                </el-option>
              </el-select>
              <!-- <el-input v-model.trim="scope.row.retouchingPerson" v-if="scope.row.disable && +scope.row.taskId <= 104"></el-input> -->
              <span v-else>{{scope.row.retouchingPerson}}</span>
            </template>
          </el-table-column>
        </template>
        <!-- 渲染计划 -->
        <template v-if="renderPlan">
          <!-- 是否跳过了渲染节点 -->
          <template v-if="!isJumpRender">
            <el-table-column label="计划渲染" prop="planDesign" show-overflow-tooltip width="225">
              <template slot-scope="scope">
                <el-date-picker
                  v-if="scope.row.disable"
                  class="date-input"
                  size="mini"
                  :picker-options="pickerOptions"
                  v-model="scope.row.renderPlan"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
                <span v-else>{{scope.row.renderPlanDisp}}</span>
              </template>
            </el-table-column>
            <el-table-column label="实际渲染" prop="actualDesign" show-overflow-tooltip width="150px">
              <template slot-scope="scope">
                {{scope.row.actualRenderStart}}
                <span v-if="scope.row.actualRenderEnd"> 至 {{scope.row.actualRenderEnd}}</span>
              </template>
            </el-table-column>
            <el-table-column label="渲染人员" prop="planRenderPersonId" show-overflow-tooltip width="120px">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.planRenderPerson"
                  filterable=""
                  placeholder="请选择"
                  v-if="scope.row.disable && +scope.row.taskId <= 107"
                  >
                  <el-option
                    v-for="item in userList"
                    :key="item.userId"
                    :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                    :value="item.userId">
                  </el-option>
                </el-select>
                <!-- <el-input v-model.trim="scope.row.designPerson" v-if="scope.row.disable && +scope.row.taskId <= 107"></el-input> -->
                <span v-else>{{scope.row.planRenderPerson}}</span>
              </template>
            </el-table-column>
          </template>
        </template>
        <!-- 设计计划 -->
        <template v-if="hasPagePlan">
          <!-- 是否跳过了设计节点 -->
          <!-- <template v-if="!isJumpDesign">
            <el-table-column label="计划设计" prop="planDesign" show-overflow-tooltip width="225">
              <template slot-scope="scope">
                <el-date-picker
                  v-if="scope.row.disable && scope.row.taskId <= stepEnum.design"
                  class="date-input"
                  size="mini"
                  :picker-options="pickerOptions"
                  v-model="scope.row.designPlan"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
                <span v-else>{{scope.row.designPlanDisp}}</span>
              </template>
            </el-table-column>
            <el-table-column label="实际设计" prop="actualDesign" show-overflow-tooltip width="150px">
              <template slot-scope="scope">
                {{scope.row.actualDesignStart}}
                <span v-if="scope.row.actualDesign"> 至 {{scope.row.actualDesign}}</span>
              </template>
            </el-table-column>
            <el-table-column label="设计人员" prop="designPersonId" show-overflow-tooltip width="120px">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.designPersonId"
                  filterable=""
                  placeholder="请选择"
                   v-if="scope.row.disable && +scope.row.taskId <= 107"
                  >
                  <el-option
                    v-for="item in userList"
                    :key="item.userId"
                    :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                    :value="item.userId">
                  </el-option>
                </el-select>
                <span v-else>{{scope.row.designPerson}}</span>
              </template>
            </el-table-column>
          </template> -->
          <el-table-column label="计划切片" prop="planSection" show-overflow-tooltip width="225">
            <template slot-scope="scope">
              <el-date-picker
                v-if="scope.row.disable && scope.row.taskId <= stepEnum.sectioning"
                class="date-input"
                size="mini"
                :picker-options="pickerOptions"
                v-model="scope.row.sectionPlan"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <span v-else>{{scope.row.sectionPlanDisp}}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际切片" prop="actualSection" show-overflow-tooltip width="150px">
            <template slot-scope="scope">
              {{scope.row.actualSectionStart}}
              <span v-if="scope.row.actualSection"> 至 {{scope.row.actualSection}}</span>
            </template>
          </el-table-column>
          <el-table-column label="切片人员" prop="sectionPersonId" show-overflow-tooltip width="120px">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.sectionPersonId"
                filterable=""
                placeholder="请选择"
                v-if="scope.row.disable && +scope.row.taskId <= 108"
                >
                <el-option
                  v-for="item in userList"
                  :key="item.userId"
                  :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                  :value="item.userId">
                </el-option>
              </el-select>
              <!-- <el-input v-model.trim="scope.row.sectionPerson" v-if="scope.row.disable && +scope.row.taskId <= 108"></el-input> -->
              <span v-else>{{scope.row.sectionPerson}}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" fixed="right" width="90px" align="center">
          <template slot-scope="scope">
            <template v-if="+scope.row.taskId < 109">
              <el-link
                :underline="false"
                type="primary"
                @click="edit(scope.row)"
                v-if="!scope.row.disable"
                v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$workPlanEdit`">调整</el-link>
              <template v-else>
                <el-link :underline="false" type="primary" @click="cancel(scope.row)">取消</el-link>
                <el-link :underline="false" type="primary" @click="save(scope.row)">保存</el-link>
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </q-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import axios from "@/utils/axiosInstance";
  import {newProductStepEnum as stepEnum} from '@/utils/constant'

  export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'spuId', 'activeStepIndex', 'currentStep', 'hasPhotographyPlan', 'hasPagePlan', 'isJumpDesign', 'renderPlan','isJumpRender'],
  data() {
    const ONE_DAY_MILLSECONDS = 24 * 60 * 60 * 1000;
    return {
      // 业务
      loading: false,
      formData: {
        overTime: ''
      },
      tableData: [],
      planPersonList: [],
      isNeedRefresh: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < (Date.now() - ONE_DAY_MILLSECONDS);
        }
      },
      publishedTable: [],
      unPublishTableSelected: [],
      stepEnum: stepEnum,
      userList: [],
      captureUserList: [],
      spanArr: [],
      spanArrPublished: [], // publishedTable的合并数组
      pos: 0,
      currentEditRowIndex: -1, // 当前编辑行的索引
      isEditingPublished: false, // 是否编辑publishedTable
    }
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  mounted() {
    // 业务
    this.init();
    this.getUserList();
    this.getCaptureUserList();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      if (this.isNeedRefresh) {
        this.$emit('success');
      }
    },
    confirm() {
      this.$refs['ruleForm'].validate(valid=>{
        if(valid) {
          this.updateVal();
        }
      })
    },
    // 业务
    handleSearch() {
      this.init();
    },
    reset() {
      this.formData = {
        overTime: ''
      }
      this.init();
    },
    init() {
      this.loading = true;
      this.getPersonList();
      let formData = {
        ...this.formData,
        spuId: this.spuId
      };
      this.$q.newProduct.startShootingPlanList({data: formData})
      .then(res=>{
        const formatDate = (dateVal) => {
          if (!dateVal) {
            return '';
          }
          return moment(dateVal, 'YYYY-MM-DD').toDate();
        }
        this.tableData = res.data.map(item => {
          // 拍摄
          const shootingStart = formatDate(item.planShooting);
          const shootingEnd = formatDate(item.shootingEnd);item.shootingEnd ? moment(item.shootingEnd, 'YYYY-MM-DD').toDate() : '';
          const shootingPlanDisp = (item.planShooting || item.shootingEnd) ? `${item.planShooting || ''} 至 ${item.shootingEnd || ''}` : '';
          // 修片
          const retouchingStart = formatDate(item.planRetouching);
          const retouchingEnd = formatDate(item.retouchingEnd);
          const retouchingPlanDisp = (item.planRetouching || item.retouchingEnd) ? `${item.planRetouching || ''} 至 ${item.retouchingEnd || ''}` : '';
          // 设计
          const designStart = formatDate(item.planDesign);
          const designEnd = formatDate(item.designEnd);
          const designPlanDisp = (item.planDesign || item.designEnd) ? `${item.planDesign || ''} 至 ${item.designEnd || ''}` : '';
          // 切片
          const sectionStart = formatDate(item.planSection);
          const sectionEnd = formatDate(item.sectionEnd);
          const sectionPlanDisp = (item.planSection || item.sectionEnd) ? `${item.planSection || ''} 至 ${item.sectionEnd || ''}` : '';
          //渲染
          const renderStart = formatDate(item.planRenderStart)
          const planRenderEnd = formatDate(item.planRenderEnd)
          const renderPlanDisp = (item.planRenderStart || item.planRenderEnd) ? `${item.planRenderStart || ''} 至 ${item.planRenderEnd || ''}` : '';

          return {
            ...item,
            shootingPlan: [shootingStart, shootingEnd],
            shootingPlanDisp,
            retouchingPlan: [retouchingStart, retouchingEnd],
            retouchingPlanDisp,
            designPlan: [designStart, designEnd],
            designPlanDisp,
            sectionPlan: [sectionStart, sectionEnd],
            sectionPlanDisp,
            renderPlan: [renderStart, planRenderEnd],
            renderPlanDisp,
          }
        });
        this.getSpanArr(this.tableData);
      })
      .finally(_=>{
        this.loading = false;
      })
    },
    tableRowClassName({row, rowIndex}) {
      if(row.disable) {
        return 'success-row'
      }else{
        return ''
      }
    },
    edit(row) {
      // 判断是编辑哪个表格
      let foundInPublished = false;
      this.publishedTable.forEach((item, index) => {
        this.$set(item, 'disable', false)
        if (item === row) {
          this.currentEditRowIndex = index;
          foundInPublished = true;
        }
      })
      
      if (!foundInPublished) {
        this.tableData.forEach((item, index) => {
          this.$set(item, 'disable', false)
          if (item === row) {
            this.currentEditRowIndex = index;
          }
        })
      }
      
      this.isEditingPublished = foundInPublished;
      this.$set(row, 'disable', true)
    },
    cancel(row) {
      row.disable = false;
      this.currentEditRowIndex = -1;
      this.isEditingPublished = false;
      this.init();
    },
    save(row) {
      // 拍摄
      const [planShooting = '', shootingEnd = ''] = row.shootingPlan || [];
      const {shootPersonId} = row;
      // 修片
      const [planRetouching = '', retouchingEnd = ''] = row.retouchingPlan || [];
      const {retouchingPersonId} = row;
      // 设计
      const [planDesign = '', designEnd = ''] = row.designPlan || [];
      const {designPersonId} = row;
      // 切片
      const [planSection = '', sectionEnd = ''] = row.sectionPlan || [];
      const {sectionPersonId} = row;
      // 渲染
      const [planRenderStart = '', planRenderEnd = ''] = row.renderPlan || [];
      const {planRenderPersonId} = row; 

      if((planShooting || shootingEnd || shootPersonId) && (!planShooting || !shootingEnd || !shootPersonId)) {
        this.$message.error('请维护完整的拍摄计划');
        return;
      }
      if((planRetouching || retouchingEnd || retouchingPersonId) && (!planRetouching || !retouchingEnd || !retouchingPersonId)) {
        this.$message.error('请维护完整的计划修片');
        return;
      }
      // if((planDesign || designEnd || designPersonId) && (!planDesign || !designEnd || !designPersonId)) {
      //   this.$message.error('请维护完整的计划设计');
      //   return;
      // }
      if((planSection || sectionEnd || sectionPersonId) && (!planSection || !sectionEnd || !sectionPersonId)) {
        this.$message.error('请维护完整的计划切片');
        return;
      }
      if((planRenderStart || planRenderEnd || planRenderPersonId) && (!planRenderStart || !planRenderEnd || !planRenderPersonId)) {
        this.$message.error('请维护完整的计划渲染');
        return;
      }

      // if(this.currentStep > 103 || this.currentStep == 103) {
      //   if(!planShooting || !shootingEnd){
      //     this.$message.error('请填写拍摄计划');
      //     return;
      //   }
      //   if(!row.shootPerson){
      //     this.$message.error('请填写拍摄人员');
      //     return;
      //   }
      // }
      // if(this.currentStep > 104 || this.currentStep == 104) {
      //   if(!planRetouching || !retouchingEnd){
      //     this.$message.error('请填写计划修片');
      //     return;
      //   }
      //   if(!row.retouchingPerson){
      //     this.$message.error('请填写修片人员');
      //     return;
      //   }
      // }
      // if(this.currentStep > 107 || this.currentStep == 107) {
      //   if(!planDesign || !designEnd){
      //     this.$message.error('请填写计划设计');
      //     return;
      //   }
      //   if(!row.designPerson){
      //     this.$message.error('请填写设计人员');
      //     return;
      //   }
      // }
      // if(this.currentStep > 108 || this.currentStep == 108) {
      //   if(!planSection || !sectionEnd){
      //     this.$message.error('请填写计划切片');
      //     return;
      //   }
      //   if(!row.sectionPerson){
      //     this.$message.error('请填写切片人员');
      //     return;
      //   }
      // }

      const formatDate = (dateVal) => {
        if (!dateVal) {
          return '';
        }
        return moment(dateVal).format('YYYY-MM-DD')
      }

      // 查找当前编辑行所在的合并组
      let dataArr = [];
      const currentRowIndex = this.currentEditRowIndex;
      const currentTable = this.isEditingPublished ? this.publishedTable : this.tableData;
      const currentSpanArr = this.isEditingPublished ? this.spanArrPublished : this.spanArr;
      
      // 找到合并组的起始行索引和合并数量
      let spanStartIndex = currentRowIndex;
      let spanCount = currentSpanArr[currentRowIndex] || 1;
      
      // 如果当前行的 spanArr 值为 0，说明这不是起始行，需要向前查找
      if (spanCount === 0) {
        for (let i = currentRowIndex - 1; i >= 0; i--) {
          if (currentSpanArr[i] > 0) {
            spanStartIndex = i;
            spanCount = currentSpanArr[i];
            break;
          }
        }
      }
      // 如果是合并行（spanCount > 1），需要提交所有合并的行
      if (spanCount > 1) {
        // 从起始行开始，获取所有合并的行
        for (let i = 0; i < spanCount; i++) {
          const targetRow = currentTable[spanStartIndex + i];
          // 每一行保留自己原有的字段值，只有切片相关的3列使用编辑行的值
          const [targetPlanShooting = '', targetShootingEnd = ''] = targetRow.shootingPlan || [];
          const [targetPlanRetouching = '', targetRetouchingEnd = ''] = targetRow.retouchingPlan || [];
          const [targetPlanDesign = '', targetDesignEnd = ''] = targetRow.designPlan || [];
          const [targetPlanRenderStart = '', targetPlanRenderEnd = ''] = targetRow.renderPlan || [];
          
          dataArr.push({
            spuId: this.spuId,
            skuCode: targetRow.skuCode,
            taskId: targetRow.taskId,
            // 使用各自的拍摄计划
            planShooting: formatDate(targetPlanShooting),
            shootingEnd: formatDate(targetShootingEnd),
            shootPersonId: targetRow.shootPersonId || '',
            shootPerson: targetRow.shootPersonId ? this.captureUserList.find(v => v.userId == targetRow.shootPersonId).userName || "" : "",
            // 使用各自的修片计划
            planRetouching: formatDate(targetPlanRetouching),
            retouchingEnd: formatDate(targetRetouchingEnd),
            retouchingPersonId: targetRow.retouchingPersonId || '',
            retouchingPerson: targetRow.retouchingPersonId ? this.userList.find(v => v.userId == targetRow.retouchingPersonId).userName || "" : "",
            // 使用各自的设计计划
            planDesign: formatDate(targetPlanDesign),
            designEnd: formatDate(targetDesignEnd),
            designPersonId: targetRow.designPersonId || '',
            designPerson: targetRow.designPersonId ? this.userList.find(v => v.userId == targetRow.designPersonId).userName || "" : "",
            // 切片相关使用编辑行的值
            planSection: formatDate(planSection),
            sectionEnd: formatDate(sectionEnd),
            sectionPersonId: row.sectionPersonId || '',
            sectionPerson: row.sectionPersonId ? this.userList.find(v => v.userId == row.sectionPersonId).userName || "" : "",
            // 使用各自的渲染计划
            planRenderStart: formatDate(targetPlanRenderStart),
            planRenderEnd: formatDate(targetPlanRenderEnd),
            planRenderPersonId: targetRow.planRenderPersonId || '',
            planRenderPerson: targetRow.planRenderPersonId ? this.userList.find(v => v.userId == targetRow.planRenderPersonId).userName || "" : "",
          });
        }
      } else {
        // 非合并行，只提交当前行
        dataArr.push({
          spuId: this.spuId,
          skuCode: row.skuCode,
          taskId: row.taskId,
          planShooting: formatDate(planShooting),
          shootingEnd: formatDate(shootingEnd),
          shootPersonId: row.shootPersonId || '',
          shootPerson: row.shootPersonId ? this.captureUserList.find(v => v.userId == row.shootPersonId).userName : "",
          planRetouching: formatDate(planRetouching),
          retouchingEnd: formatDate(retouchingEnd),
          retouchingPersonId: row.retouchingPersonId || '',
          retouchingPerson: row.retouchingPersonId ? this.userList.find(v => v.userId == row.retouchingPersonId).userName : "",
          planDesign: formatDate(planDesign),
          designEnd: formatDate(designEnd),
          designPersonId: row.designPersonId || '',
          designPerson: row.designPersonId ? this.userList.find(v => v.userId == row.designPersonId).userName : "",
          planSection: formatDate(planSection),
          sectionEnd: formatDate(sectionEnd),
          sectionPersonId: row.sectionPersonId || '',
          sectionPerson: row.sectionPersonId ? this.userList.find(v => v.userId == row.sectionPersonId).userName : "",
          planRenderStart: formatDate(planRenderStart),
          planRenderEnd: formatDate(planRenderEnd),
          planRenderPersonId: row.planRenderPersonId || '',
          planRenderPerson: row.planRenderPersonId ? this.userList.find(v => v.userId == row.planRenderPersonId).userName : "",
        });
      }
      
      this.$q.newProduct.planAdjustment({data: dataArr})
      .then(res=>{
        if(res.code == 200) {
          this.isNeedRefresh = true;
          this.$message.success('保存成功');
        }else{
          this.$message.error(res.message);
        }
      })
      .finally(_=>{
        row.disable = false;
        this.currentEditRowIndex = -1;
        this.isEditingPublished = false;
        this.init();
      })
    },
    getPersonList() {
      const params = {
        fragment: [this.spuId]
      };
      this.$q.newProduct.getPlanPersons(params)
        .then(res=>{
          this.planPersonList = res.data || [];
        });
    },
    batchUpdate() {
      if(this.publishedTable.length) {
        this.publishedTable = [];
        this.tableData = [];
        this.init();
        return;
      }

      let publishedTable = this.tableData.filter(v=>{
        // 拍摄计划和页面计划，各自的四个参数只要有一个参数有值就算是维护了的。
        let status1 =  v.planShooting || v.shootPersonId || v.planRetouching || v.retouchingPersonId
        let status2 =  v.planDesign || v.designPersonId || v.planSection || v.sectionPersonId
        return (status1 || status2)
      })
      this.publishedTable = JSON.parse(JSON.stringify(publishedTable));
      // 为 publishedTable 计算合并数组
      this.getSpanArr(this.publishedTable, true);

      if(!this.publishedTable.length) {
        this.$message('没有已填写的计划可批量操作')
      }
    },
    getUserList() {
      let data = {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "getUserInfoByName",
      }
      axios.post(`/ec-pc-api/custom/reports/data/getUserInfoByName`, data).then((res) => {
        if (res.code == 200) {
          console.log(res.data);
          this.userList = res.data.list;
        }
      });
    },
    getCaptureUserList() {
      let data = {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "getShooterInfoByName",
      }
      axios.post(`/ec-pc-api/custom/reports/data/getShooterInfoByName`, data).then((res) => {
        if (res.code == 200) {
          this.captureUserList = res.data.list;
        }
      });
    },
    handleSelected(data) {
      this.unPublishTableSelected = data;
    },
    asyncPlan(row) {
      if(this.unPublishTableSelected.length == 0) {
        this.$message.error('请先勾选需要同步的SKU');
        return;
      }
      // 拍摄
      const [planShooting = '', shootingEnd = ''] = row.shootingPlan || [];
      // 修片
      const [planRetouching = '', retouchingEnd = ''] = row.retouchingPlan || [];
      // 设计
      const [planDesign = '', designEnd = ''] = row.designPlan || [];
      // 切片
      const [planSection = '', sectionEnd = ''] = row.sectionPlan || [];
      // 渲染
      const [planRenderStart = '', planRenderEnd = ''] = row.renderPlan || [];

      const formatDate = (dateVal) => {
        if (!dateVal) {
          return '';
        }
        return moment(dateVal).format('YYYY-MM-DD')
      }

      let arr = [];
      this.unPublishTableSelected.forEach(item=>{
        arr.push({
          spuId: this.spuId,
          skuCode: item.skuCode,
          taskId: item.taskId,
          planShooting: formatDate(planShooting),
          shootingEnd: formatDate(shootingEnd),
          shootPersonId: row.shootPersonId || '',
          shootPerson: row.shootPerson || '',
          planRetouching: formatDate(planRetouching),
          retouchingEnd: formatDate(retouchingEnd),
          retouchingPersonId: row.retouchingPersonId || '',
          retouchingPerson: row.retouchingPerson || '',
          planDesign: formatDate(planDesign),
          designEnd: formatDate(designEnd),
          designPersonId: row.designPersonId || '',
          designPerson: row.designPerson || '',
          planSection: formatDate(planSection),
          sectionEnd: formatDate(sectionEnd),
          sectionPersonId: row.sectionPersonId || '',
          sectionPerson: row.sectionPerson || '',
          planRenderStart: formatDate(planRenderStart),
          planRenderEnd: formatDate(planRenderEnd),
          sectionPersonId: row.planRenderPersonId || '',
          planRenderPerson: row.planRenderPerson || '',
        })
      })
      this.$q.newProduct.planAdjustment({data: arr})
      .then(res=>{
        if(res.code == 200) {
          this.isNeedRefresh = true;
          this.$message.success('保存成功');
        }else{
          this.$message.error(res.message);
        }
      })
      .finally(_=>{
        row.disable = false;
        this.batchUpdate();
      })
    },
    // 获取需要合并的行数组
    getSpanArr(data, isPublished = false) {
      const spanArr = [];
      let pos = 0;
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          spanArr.push(1);
          pos = 0;
        } else {
          // 判断当前行的切片相关数据是否与上一行相同
          if (
            data[i].sectionPlanDisp === data[i - 1].sectionPlanDisp &&
            data[i].actualSectionStart === data[i - 1].actualSectionStart &&
            data[i].actualSection === data[i - 1].actualSection &&
            data[i].sectionPersonId === data[i - 1].sectionPersonId &&
            data[i].sectionPlanDisp // 只有当有值时才合并
          ) {
            spanArr[pos] += 1;
            spanArr.push(0);
          } else {
            spanArr.push(1);
            pos = i;
          }
        }
      }
      
      if (isPublished) {
        this.spanArrPublished = spanArr;
      } else {
        this.spanArr = spanArr;
      }
    },
    // 合并单元格方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      // 获取列的属性名
      const prop = column.property;
      
      // 只对计划切片、实际切片、切片人员列进行合并
      if (prop === 'planSection' || prop === 'actualSection' || prop === 'sectionPersonId') {
        // 判断当前行是否在 publishedTable 中
        const isInPublished = this.publishedTable.some(item => item === row);
        const currentSpanArr = isInPublished ? this.spanArrPublished : this.spanArr;
        const _row = currentSpanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-table
    td
      height 26px
    .success-row
      background #f0f9eb
      td
        height 40px
        transition all linear .2s
        .el-input input
          height 30px
          width 100%

  >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
    width 100%
  .date-input
    width 200px !important
</style>
